import { render, staticRenderFns } from "./MaterialControlsZoom.vue?vue&type=template&id=8a7acfd6&scoped=true&"
import script from "./MaterialControlsZoom.vue?vue&type=script&lang=js&"
export * from "./MaterialControlsZoom.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/material_controls.css?vue&type=style&index=0&id=8a7acfd6&prod&scoped=true&lang=css&"
import style1 from "./MaterialControlsZoom.vue?vue&type=style&index=1&id=8a7acfd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7acfd6",
  null
  
)

export default component.exports